<template>
  <div class="analytics channel-analytics">
    <filter-bar :timeframe="timeframe" @change="setTimeframe" />
    <stats
      :data="basicMetrics"
      :props="basicMetricProps"
      :min-width="minWidth"
    />

    <treemap
      v-if="treemapItems && dimensions"
      :items="treemapItems"
      :width="dimensions.width"
      :height="800"
      :min-width="minWidth"
      :type="'account'"
    />

    <line-chart
      v-if="dimensions"
      :items="items"
      :width="dimensions.width"
      :timeframe-labels="timeframeLabels"
      :height="400"
      :min-width="minWidth"
      :timeframe="timeframe"
    />

    <ranking-list
      title="Top Articles"
      :items="
        (cogData ? cogData.topArticlesByTimeframe[timeframe] : []).map((tr) => ({
          id: tr.articleId,
          name: tr.article ? tr.article.title : '-',
          value: tr.views,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        }))
      "
      :active-id="data.id"
      :settings="{
        title: 'Top Articles',
        path: 'articles',
        colWidth: 12,
        activeEnabled: true,
        cols: ['name', 'channel', 'analyst', 'webDownloads', 'engagement'],
        type: 'infinity-rank',
      }"
      :client-width="clientWidth"
    />
    <!-- <filter-buttons
      :items="metricProps"
      :active="metricActive"
      :loading="metricItemsLoading"
      @change="setMetricActive"
    /> -->

    <!-- <treemap
      v-if="dimensions"
      :items="metricActive in metricItems ? metricItems[metricActive] : null"
      :width="dimensions.width"
      :height="800"
      :min-width="minWidth"
      :type="metricActive"
      :enable-link="getMetric(metricActive).link"
      :show-title="false"
      mode="surface"
    /> -->
  </div>
</template>

<script>
import RankingList from '@/components/RankingList'
import { constructReadership } from '@/analytics/data-analyser'

import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import axios from 'axios'
import TimeframeMixin from '@/analytics/mixins/TimeframeMixin'

import FilterBar from '@/components/FilterBar'
import Stats from '@/components/Stats'
import FilterButtons from '@/components/FilterButtons'
import LineChart from '@/components/d3/LineChart'
import Treemap from '@/components/d3/Treemap'

export default {
  components: {
    FilterBar,
    Stats,
    FilterButtons,
    LineChart,
    Treemap,
    RankingList,
  },
  mixins: [AnalyticsMixin, TimeframeMixin],

  async mounted() {
    const response = await this.loadData(
      'dashboard',
      this.timeframe,
      this.data.id
    )
  },

  data() {
    return {
      cogData: undefined,
      analyticsType: 'channel',
      basicMetricProps: ['emailOpens', 'emailClicks', 'webViews'],
      metricProps: [
        { name: 'Key Topics', value: 'topic', link: false, attr: 'custom' },
        {
          name: 'Readers',
          value: 'user',
          link: true,
          attr: 'custom_attributes.user_id',
        },
        {
          name: 'Articles',
          value: 'article',
          link: true,
          attr: 'custom_attributes.alertable_id',
        },
        {
          name: 'Analysts',
          value: 'analyst',
          link: true,
          attr: 'custom_attributes.primary_analyst_id',
        },
        {
          name: 'Companies',
          value: 'company',
          link: true,
          attr: 'custom_attributes.company_id',
        },
        { name: 'Geography', value: 'geography', link: false, attr: 'custom' },
        {
          name: 'Country Readers',
          value: 'geo-country',
          link: false,
          attr: 'geo.country',
        },
        { name: 'Sectors', value: 'sector', link: false, attr: null },
      ],
    }
  },

  computed: {
    timeframeLabels() {
      if (!this.cogData) {
        return []
      }

      const labels = this.cogData.series[this.timeframe].webViewsDaily.map(
        (item) => item.date
      )
      return labels
    },

    items() {
      const items = this.cogData
      console.log('ohno', items)
      if (!items) {
        return {
          key: 'webViews',
          val: [],
          name: 'Web views',
        }
      }

      return {
        webViews: items.series[this.timeframe].webViewsDaily.map(
          (d) => d.value
        ),
      }
    },
  },
  watch: {
    timeframe: function (timeframe, oldData) {
      // this.loadData(timeframe)
      if (this.cogData) {
        this.treemapItems = this.cogData.engagement[
          this.timeframe
        ].accounts.map((ae) => ({
          id: ae.id.toString(),
          name: ae.name,
          value: ae.value,
          lastValue: ae.lastValue,
          diffNum: ae.difference,
          diffStr: ae.differenceText,
          valueRank: ae.rank,
          lastValueRank: ae.prevRank,
          change: ae.rankChange,
          position: ae.rank,
        }))
        this.readership = {
          webViews: this.cogData.series[this.timeframe].webViewsDaily.map(
            (x) => x.value
          ),
        }
        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
        const userStat = {
          gdpr: this.data.is_gdpr_compliant,
          reader: this.basicMetrics.current.webViews,
        }
        this.$set(this.basicMetrics.current, 'userStat', userStat)
      }
    },

    cogData() {
      this.treemapItems = this.cogData.engagement[this.timeframe].accounts.map(
        (ae) => ({
          id: ae.id.toString(),
          name: ae.name,
          value: ae.value,
          lastValue: ae.lastValue,
          diffNum: ae.difference,
          diffStr: ae.differenceText,
          valueRank: ae.rank,
          lastValueRank: ae.prevRank,
          change: ae.rankChange,
          position: ae.rank,
        })
      )
      this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
      this.readership = {
        webViews: this.cogData.series[this.timeframe].webViewsDaily.map(
          (x) => x.value
        ),
      }
      const userStat = {
        gdpr: this.data.is_gdpr_compliant,
        reader: this.basicMetrics.current.webViews,
      }
      this.$set(this.basicMetrics.current, 'userStat', userStat)
    },
    // metricActive: function () {
    //   this.constructMetricItems()
    // },
  },
}
</script>
